import React from 'react';
import { connect, DispatchProp } from 'react-redux';

import { Link } from '@dndbeyond/character-common-components/es';
import {
    characterActions,
    DecorationInfo,
    DecorationUtils,
    rulesEngineSelectors,
} from '@dndbeyond/character-rules-engine/es';

import { modalActions } from '../../../Shared/actions';
import FormInputField from '../../../Shared/components/common/FormInputField';
import { BuilderAppState } from '../../typings';
import { CharacterAvatarPortrait } from '@dndbeyond/character-components/es';

interface Props extends DispatchProp {
    name: string | null;
    decorationInfo: DecorationInfo;
}
class PortraitName extends React.PureComponent<Props> {
    handleNameChange = (value: string | null): void => {
        const { dispatch } = this.props;
        dispatch(characterActions.nameSet(value));
    };

    handleRandomNameClick = (): void => {
        const { dispatch } = this.props;
        dispatch(characterActions.randomNameRequest());
    };

    handleAvatarEdit = (evt: React.MouseEvent): void => {
        const { dispatch } = this.props;
        dispatch(modalActions.open('avatar'));
    };

    render() {
        const { name, decorationInfo } = this.props;
        const inputAttrs = {
            spellCheck: false,
            autoComplete: 'off',
        };

        const avatarUrl = DecorationUtils.getAvatarInfo(decorationInfo).avatarUrl;
        const portraitClassNames: Array<string> = ['portrait-name-avatar'];
        if (!avatarUrl) {
            portraitClassNames.push('portrait-name-avatar-none');
        }

        return (
            <div className="portrait-name">
                <div  onClick={this.handleAvatarEdit}>
                    <CharacterAvatarPortrait
                        className={portraitClassNames.join(' ')}
                        avatarUrl={avatarUrl}
                    />
                </div>
                <div className="portrait-name-naming">
                    <div className="portrait-name-naming-randomize">
                        <Link onClick={this.handleRandomNameClick}>Randomize</Link>
                    </div>
                    <FormInputField
                        label="Character Name"
                        onBlur={this.handleNameChange}
                        initialValue={name}
                        inputAttributes={inputAttrs}
                    />
                    <div className="portrait-name-naming-credit">
                        Names by
                        <Link
                            className="portrait-name-fng-logo"
                            url="http://www.fantasynamegenerators.com/"
                            target="_blank"
                        >
                            <span className="portrait-name-fng-text">Fantasy Name Generators</span>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: BuilderAppState) {
    return {
        name: rulesEngineSelectors.getName(state),
        decorationInfo: rulesEngineSelectors.getDecorationInfo(state),
    };
}

export default connect(mapStateToProps)(PortraitName);
